
import { i18nText } from '@/locales';

import {Component, Vue} from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import SiteNewsForm from "@/form/Settings/site/news";
import SiteNewsUpdateForm from "@/form/Settings/site/newsUpdate";
import {NewsStore} from "@/store/modules/Settings/News";
import {INews, INewsListItem, NewsResponseType} from '@/entity/Settings/news.types';
import {message} from "ant-design-vue";

import NewsUpdateForm from "@/UI/components/forms/settings/news/NewsUpdateForm.vue";


@Component({
  components: {
    PageTitle, FormGroup, NewsUpdateForm
  }
})
export default class News extends Vue {
  form = new SiteNewsForm();
  updateForm = new SiteNewsUpdateForm();
  modal_form: boolean = false;
  update_modal_form: boolean = false;
  loading: boolean = false;
  imageUrl: string = '';

  async saveNews(): Promise<void> {
    if (await this.form.submit(NewsStore.create)) {
      this.modal_form = false;
      await NewsStore.fetchAll();
    }
  }

  async updateNews(): Promise<void> {
    if (await this.updateForm.submit(NewsStore.update)) {
      this.update_modal_form = false;
      await NewsStore.fetchAll();
    }
  }

  async deleteNews(item: any): Promise<void> {
    if (await NewsStore.delete({id: parseInt(item)})) {
      await NewsStore.fetchAll();
      message.success(i18nText("Данные успешно удалены"));
    } else {
      message.error(i18nText("Что то пошло не так..."))
    }
  }

  showUpdateForm(news: INewsListItem) {
    this.updateForm = new SiteNewsUpdateForm();
    this.updateForm.setFormData(news);
    this.update_modal_form = true;
    console.log(this.updateForm);
  }

  getBase64(img: any, callback: any) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  handleImageChange(info:any) {
    if (info.file.status === 'uploading') {
      this.loading = true;
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      this.getBase64(info.file.originFileObj, (imageUrl: string) => {
        this.imageUrl = imageUrl;
        this.loading = false;
      });

      this.form.image_file = info.file.originFileObj;
    }
  }

  beforeImageUpload(file: any): boolean {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      this.$message.error(i18nText("Загружать можно JPG или PNG файлы"));
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.$message.error(i18nText("Изображение должно быть меньше, чем 2MB!"));
    }
    return isJpgOrPng && isLt2M;
  }

  async created(): Promise<void> {
    await NewsStore.fetchAll();
  }

  get news(): INews | null {
    return NewsStore.news;
  }

}
